export const SPONSOR_PITCH_TABS = [
  {
    slug: 'master',
    label: 'Master',
    description: 'Source of truth',
  },
  {
    slug: 'the-licenced',
    label: 'The Licenced',
    description: 'Sponsor edition',
  },
  {
    slug: 'gold',
    label: 'Gold by Hemas',
    description: 'Sponsor edition',
  },
  {
    slug: 'pop-culture',
    label: 'Pop Culture',
    description: 'Sponsor edition',
  },
  {
    slug: 'camera-lk',
    label: 'Camera.lk',
    description: 'Sponsor edition',
  },
  {
    slug: 'cookware-lk',
    label: 'Cookware.lk',
    description: 'Sponsor edition',
  },
] as const

export const AUDIENCE_PREVIEW_TAB = {
  key: 'audience-preview',
  label: 'Audience preview',
  description: 'Derived from Master',
} as const

export type SponsorPitchTabSlug = (typeof SPONSOR_PITCH_TABS)[number]['slug']

export function isSponsorPitchTabSlug(value: string | undefined | null): value is SponsorPitchTabSlug {
  return SPONSOR_PITCH_TABS.some((tab) => tab.slug === value)
}

export function sponsorPitchTabForSlug(value: string | undefined | null) {
  return SPONSOR_PITCH_TABS.find((tab) => tab.slug === value) ?? SPONSOR_PITCH_TABS[0]
}
